function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .icon_menu_relatorio_analitico_a{fill:#fff;stroke:#707070;}\n      .icon_menu_relatorio_analitico_b{clip-path:url(#icon_menu_relatorio_analitico_a);}\n      .icon_menu_relatorio_analitico_c{fill:#cfd8dc;}\n      .icon_menu_relatorio_analitico_d{fill:#b4bcc0;}\n      .icon_menu_relatorio_analitico_e{fill:#f5f5f5;}\n      .icon_menu_relatorio_analitico_f{fill:#607d8b;}\n      .icon_menu_relatorio_analitico_g{fill:#d5d5d5;}\n      .icon_menu_relatorio_analitico_h{fill:#546d79;}\n      .icon_menu_relatorio_analitico_i{fill:#03a9f4;}\n      .icon_menu_relatorio_analitico_j{fill:#0393d4;}\n    "), React.createElement("clipPath", {
  id: "icon_menu_relatorio_analitico_a"
}, React.createElement("rect", {
  className: "icon_menu_relatorio_analitico_a",
  width: 19,
  height: 19,
  transform: "translate(1800 1048)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_menu_relatorio_analitico_b",
  transform: "translate(-1800 -1048)"
}, React.createElement("g", {
  transform: "translate(1800 1047.604)"
}, React.createElement("path", {
  className: "icon_menu_relatorio_analitico_c",
  d: "M12.864,19a.784.784,0,0,1-.429-.127L9.07,16.7a.792.792,0,1,1,.861-1.329L13.3,17.543A.792.792,0,0,1,12.864,19Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_c",
  d: "M9.5,19a.792.792,0,0,1-.792-.792V13.854a.792.792,0,1,1,1.583,0v4.354A.792.792,0,0,1,9.5,19Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_c",
  d: "M6.136,19a.792.792,0,0,1-.431-1.457L9.07,15.366A.792.792,0,0,1,9.931,16.7L6.566,18.873a.79.79,0,0,1-.43.127Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_d",
  d: "M9.5,16.974l-.792.512v.722A.792.792,0,0,0,9.5,19Zm0-3.912a.792.792,0,0,0-.792.792V15.6l.362-.234A.786.786,0,0,1,9.5,15.24h0Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_d",
  d: "M9.5,15.24a.786.786,0,0,0-.429.127l-.362.234-3,1.944A.791.791,0,0,0,6.136,19a.784.784,0,0,0,.429-.127l2.143-1.386.792-.512V15.24Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_e",
  d: "M16.229,14.25H2.771a1.387,1.387,0,0,1-1.385-1.385V3.76a.594.594,0,0,1,.594-.594H17.021a.594.594,0,0,1,.594.594v9.1A1.387,1.387,0,0,1,16.229,14.25Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_f",
  d: "M17.219,4.354H1.781a1.781,1.781,0,0,1,0-3.563H17.219a1.781,1.781,0,0,1,0,3.563Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_g",
  d: "M1.385,4.31v8.555A1.387,1.387,0,0,0,2.771,14.25H9.5v-9.9H1.781A1.764,1.764,0,0,1,1.385,4.31Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_h",
  d: "M9.5.792H1.781a1.781,1.781,0,0,0-.4,3.518,1.764,1.764,0,0,0,.4.044H9.5Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_i",
  d: "M5.344,12.073a.792.792,0,0,1-.552-1.359l3.023-2.94a.79.79,0,0,1,.983-.1l1.674,1.085,2.574-3.129a.792.792,0,1,1,1.223,1.006l-3.023,3.676a.792.792,0,0,1-1.043.161L8.467,9.35,5.9,11.85a.8.8,0,0,1-.553.223Z"
}), React.createElement("path", {
  className: "icon_menu_relatorio_analitico_j",
  d: "M14.159,5.524,10.633,9.812,8.366,8.342l-3.59,3.493A.792.792,0,0,0,5.9,11.85l2.571-2.5L10.2,10.477a.791.791,0,0,0,1.042-.161L14.267,6.64a.792.792,0,0,0-.108-1.115Z"
})));

var SvgRelatorioAnalitico = function SvgRelatorioAnalitico(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRelatorioAnalitico, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/relatorio-analitico.733c4ee2.svg";
export { ForwardRef as ReactComponent };